import {
  ENVS,
  getEnv,
  getRegion,
  Region,
  REGIONS,
} from '@adsk/acs-sc-web-platform-api';

import productionAPACRemoteRoutes from './remote-routes.production.apac';
import productionEMEARemoteRoutes from './remote-routes.production.emea';
import productionUSRemoteRoutes from './remote-routes.production.us';
import qaRemoteRoutes from './remote-routes.qa';
import stagingRemoteRoutes from './remote-routes.staging';
import productionRemotesAPAC from './remotes.production.apac';
import productionRemotesEMEA from './remotes.production.emea';
import productionRemotesUS from './remotes.production.us';
import qaRemotes from './remotes.qa';
import stagingRemotes from './remotes.staging';
import { Remotes, Route } from './types';

type Env = {
  remotes: Remotes;
  remoteRoutes: Route[];
};

let envConfig: Env | undefined;

const configFactoryByEnvs = {
  [ENVS.QA]: () => ({
    remotes: qaRemotes,
    remoteRoutes: qaRemoteRoutes,
  }),
  [ENVS.STAGING]: () => ({
    remotes: stagingRemotes,
    remoteRoutes: stagingRemoteRoutes,
  }),
  [ENVS.PRODUCTION]: ({ region }: { region: Region }) => {
    switch (region) {
      case REGIONS.US: {
        return {
          remotes: productionRemotesUS,
          remoteRoutes: productionUSRemoteRoutes,
        };
      }
      case REGIONS.EMEA: {
        return {
          remotes: productionRemotesEMEA,
          remoteRoutes: productionEMEARemoteRoutes,
        };
      }
      case REGIONS.APAC: {
        return {
          remotes: productionRemotesAPAC,
          remoteRoutes: productionAPACRemoteRoutes,
        };
      }
      default: {
        throw new Error(
          `Unable to find env for this region "${region}" and in production env`,
        );
      }
    }
  },
};

export const clearEnvConfig = () => {
  envConfig = undefined;
};

export const getEnvConfig = (): Env => {
  if (envConfig) {
    return envConfig;
  }

  const env = getEnv();
  const region = getRegion();

  const configFactory = configFactoryByEnvs[env];

  if (!configFactory) {
    throw Error(
      `Cannot find environment factory for 'env': "${env}" and region: "${region}"`,
    );
  }

  envConfig = configFactory({ region });

  return envConfig;
};
